<template>
    <contact-us-layout>
    <v-layout align-center justify-center row wrap fill-height>
        <!-- HUBSPOT FORM -->
        <v-flex xs12 app-container-content-page>
            <v-layout column wrap>
                <v-flex class="text-xs-center mb-4">
                    <h1 class=" display-with-label">Contact Us</h1>
                </v-flex>
                <v-flex>
                    <v-container grid-list-lg py-0 px-3>
                        <!-- HubSpot Form Container -->
                        <div class="hubspot-form-container">
                            <div class="hs-form-frame" 
                                 data-region="ap1" 
                                 data-form-id="829ed6e4-55b3-44e9-b574-752c868d5bbc" 
                                 data-portal-id="441880143">
                            </div>
                        </div>
                    </v-container>
                </v-flex>
            </v-layout>
        </v-flex>
        <!-- FOOTER -->
        <v-flex class="app-contact-us-footer elevation-0">
            <app-card-faqs></app-card-faqs>
        </v-flex>
    </v-layout>
    </contact-us-layout>
</template>

<script>
  import AppCardFaqs from '../../../components/app-card/app-card-faqs'
  import ContactUsLayout from './contact-us-layout'

  export default {
    name: 'contact-us',
    components: {AppCardFaqs, ContactUsLayout},
    data () {
      return {
        // HubSpot form handles all form data and validation
      }
    },

    mounted () {
      // Set page title and meta tags
      // document.title = "Get in Touch with NannyGranny - Expert Care Solutions Across Australia"
      
      // const updateMetaTag = (name, content) => {
      //   let metaTag = document.querySelector(`meta[name="${name}"]`)
      //   if (metaTag) {
      //     metaTag.setAttribute('content', content)
      //   } else {
      //     metaTag = document.createElement('meta')
      //     metaTag.setAttribute('name', name)
      //     metaTag.setAttribute('content', content)
      //     document.head.appendChild(metaTag)
      //   }
      // }
      
      // updateMetaTag('description', "Get in touch with NannyGranny for trusted home care services. Connect with experienced carers across Australia today for inquiries, support, and personalized care solutions!")
      // updateMetaTag('title', 'Get in Touch with NannyGranny - Expert Care Solutions Across Australia')
      
      // Load HubSpot form script
      this.loadHubSpotForm()
    },

    metaInfo() {
    return {
      title: 'Get in Touch with NannyGranny - Expert Care Solutions Across Australia',
      meta: [
        {
          name: 'description',
          content: 'Get in touch with NannyGranny for trusted home care services. Connect with experienced carers across Australia today for inquiries, support, and personalized care solutions!'
        }
      ]
    }
  },

    methods: {
      loadHubSpotForm() {
        // Check if HubSpot script is already loaded
        if (document.querySelector('script[src*="js-ap1.hsforms.net"]')) {
          return
        }
        
        // Create and load HubSpot script
        const script = document.createElement('script')
        script.src = 'https://js-ap1.hsforms.net/forms/embed/441880143.js'
        script.defer = true
        script.onload = () => {
          console.log('HubSpot form script loaded successfully')
        }
        script.onerror = () => {
          console.error('Failed to load HubSpot form script')
        }
        document.head.appendChild(script)
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .hubspot-form-container
        width 100%
        max-width 600px
        margin 0 auto
        

    .display-with-label:after
        /*background-image url("../../../assets/img/brand-icons/PETS_GREEN.svg")*/
        width 50px
        bottom -66px
        right 16px
        margin-top 80px

    .app-contact-us-footer
        width 100%
        .app-need-help
            /*background-image url("../../../assets/img/ui-patterns/NG_Pattern-01-yellow.svg")*/
            background-size: 150px;
            background-position: -66px 144px;

    // HubSpot form styling
    .hs-form-frame
        width 100%
        
    // Override HubSpot default styles to match your design
    :global(.hs-form)
        font-family inherit !important
        
    :global(.hs-form .hs-input)
        border-radius 4px !important
        border 1px solid #ddd !important
        
        font-size 16px !important
        
    :global(.hs-form .hs-button)
        background-color #1976d2 !important
        color white !important
        border none !important
        padding 12px 24px !important
        border-radius 4px !important
        font-size 16px !important
        cursor pointer !important
        width 100% !important
        
    :global(.hs-form .hs-button:hover)
        background-color #1565c0 !important

    @media (min-width: 600px)
        .display-with-label:after
            width 68px
            right 10px
            bottom -30px
            
        

        .app-contact-us-footer
            width 100%
            .app-need-help
                background-size: 200px;
                background-position: -51px 114px;
                
        :global(.hs-form .hs-button)
            max-width 200px !important
            margin 0 auto !important
            display block !important
</style>


// WEBPACK FOOTER //
// src/views/content/contact-us/index.vue